var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.handleDrawer.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }